module.exports = __webpack_public_path__ + "img/copper15.339d80e0.gif";